import React, { useMemo, useState } from 'react';
import QRCode from 'react-qr-code';

/**
 * Receive flow: QR encodes the wallet id so another user can transfer cash credit from their CASH wallet here.
 */
function CashWalletReceiveQr({ walletId }) {
  const [copied, setCopied] = useState(false);
  const trimmed = typeof walletId === 'string' ? walletId.trim() : '';
  const payload = useMemo(() => {
    if (!trimmed) return '';
    try {
      return new URL(`/wallets/transfer?to=${encodeURIComponent(trimmed)}`, window.location.origin).href;
    } catch {
      return trimmed;
    }
  }, [trimmed]);

  const copyId = async () => {
    if (!trimmed || !navigator.clipboard?.writeText) return;
    try {
      await navigator.clipboard.writeText(trimmed);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  if (!trimmed || !payload) return null;

  return (
    <div
      id="cash-receive-qr"
      className="rounded-lg border border-emerald-200/80 bg-emerald-50/40 px-4 py-4 sm:flex sm:items-start sm:gap-6"
    >
      <div className="mx-auto flex w-[200px] shrink-0 flex-col items-center sm:mx-0">
        <div className="rounded-xl bg-white p-3 shadow-sm ring-1 ring-slate-200/80">
          <QRCode value={payload} size={176} level="M" />
        </div>
        <p className="mt-2 text-center text-[10px] text-slate-500">Scan to transfer credit here</p>
      </div>
      <div className="mt-4 min-w-0 flex-1 sm:mt-0">
        <p className="text-xs font-semibold uppercase tracking-wide text-emerald-800">Receive cash credit</p>
        <p className="mt-1 text-sm text-slate-700">
          After you submit physical cash to your lead (or whoever took the collection), they transfer credit from their
          wallet to yours. Show them this QR: they open <span className="font-medium">Transfer credit</span>, scan the code,
          pick their cash-credit wallet (currency CASH) and amount, then confirm.
        </p>
        <p className="mt-3 text-[10px] font-medium uppercase tracking-wide text-slate-500">Wallet ID (manual entry)</p>
        <div className="mt-1 flex flex-wrap items-center gap-2">
          <code className="max-w-full break-all rounded bg-white/90 px-2 py-1 font-mono text-xs text-slate-800 ring-1 ring-slate-200/90">
            {trimmed}
          </code>
          <button type="button" onClick={copyId} className="btn-secondary inline-flex items-center gap-1 py-1 pl-2 pr-2.5 text-xs">
            <i className="material-icons-outlined text-sm">{copied ? 'check' : 'content_copy'}</i>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CashWalletReceiveQr;
